import { Home, Person, RestaurantMenu, ShoppingCart, Summarize } from '@mui/icons-material';
import { pathDashboard, pathMenu, route } from '@/constants/routeName';
import { Link, useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { useSelector } from 'react-redux';

const parentNav = [
	{
		id: 1,
		icon: <Home fontSize='medium' />,
		label: 'Home',
		to: pathDashboard,
		isActive: (pathname) => pathname === '/' || pathname === '',
	},
	{
		id: 2,
		icon: <RestaurantMenu fontSize='medium' />,
		label: 'Menu',
		to: pathMenu,
		isActive: (pathname) => pathname === pathMenu || pathname.startsWith(`/${route.item}`),
	},
	{
		id: 3,
		icon: <Summarize fontSize='medium' />,
		label: 'Orders',
		to: `/${route.orders}`,
		isActive: (pathname) => pathname.startsWith(`/${route.orders}`),
	},
	{
		id: 4,
		icon: <ShoppingCart fontSize='medium' />,
		label: 'My Cart',
		to: `/${route.cart}`,
		isActive: (pathname) => pathname.startsWith(`/${route.cart}`),
	},
	{
		id: 5,
		icon: <Person fontSize='medium' />,
		label: 'Account',
		to: `/${route.account}`,
		isActive: (pathname) => pathname.startsWith(`/${route.account}`),
	},
];

const legacyNav = [
	{
		id: 1,
		icon: <Home fontSize='medium' />,
		label: 'Home',
		to: pathMenu,
		isActive: (pathname) => pathname === pathMenu || pathname.startsWith(`/${route.item}`),
	},
	parentNav[2],
	parentNav[3],
	parentNav[4],
];

export default function Navigation() {
	const location = useLocation();
	const cartItems = useSelector((state) => state.cart.items);
	const accountType = useSelector((state) => state.auth.accountType);

	const navS = accountType === 'legacy' ? legacyNav : parentNav;

	const { pathname } = location;

	return (
		<nav
			className='fixed bottom-0 z-10 app-container'
			aria-label='Main'
			style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
		>
			<div className='flex w-full items-stretch justify-between gap-1 border-t border-black/20 bg-bz-default px-2 pt-2 pb-2 sm:gap-4 sm:px-4 sm:pt-2.5 sm:pb-3'>
				{navS.map((n) => {
					const activeClass = n.isActive(pathname) ? 'text-black' : '';
					let showItems = false;
					if (cartItems.length && n.label === 'My Cart') {
						showItems = true;
					}
					return (
						<Link
							to={n.to}
							key={n.id}
							className={twMerge(
								'relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 text-[#787878] transition-transform duration-100 active:scale-[0.98] active:opacity-80',
								activeClass
							)}
						>
							{n.icon}
							{showItems && (
								<span className='absolute right-1 top-0 min-w-[1.1rem] rounded-full bg-black px-1 text-center text-[10px] font-bold leading-4 text-white'>
									{cartItems.length}
								</span>
							)}
							<span className='max-w-full truncate text-[11px] leading-tight sm:text-sm'>{n.label}</span>
						</Link>
					);
				})}
			</div>
		</nav>
	);
}
